import { CampaignState } from 'modules/domains/campaign';
import { PaginationInput, SortDirection, SortInput, Sorting } from 'modules/graphql';

export const DEFAULT_TYPEAHEAD_QUERY_LIMIT: PaginationInput = { offset: 0, limit: 10 };

export const DEFAULT_TYPEAHEAD_SORTING: SortInput = {
  sortBy: Sorting.UpdatedAt,
  sortDirection: SortDirection.Descending,
};

// Campaign states excluding archived
export const DISPLAYED_CAMPAIGN_STATES = Object.values(CampaignState).filter(
  (campaignState: CampaignState) => campaignState !== CampaignState.Archived,
);
